import { render, staticRenderFns } from "./bookSubmitQuestions.vue?vue&type=template&id=b6f84864&scoped=true"
import script from "./bookSubmitQuestions.vue?vue&type=script&lang=js"
export * from "./bookSubmitQuestions.vue?vue&type=script&lang=js"
import style0 from "./bookSubmitQuestions.vue?vue&type=style&index=0&id=b6f84864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f84864",
  null
  
)

export default component.exports